export { firebaseApp, firebaseAuth, firebaseDb } from './firebase';



/** WEBPACK FOOTER **
 ** ./src/core/firebase/index.js
 **/